const WebStorage = require('react-webstorage');
import {NotificationManager} from "react-notifications";
import Registry from "../Utils/Registry";
import { SignOut, IsLogged, GetAuthorizationHeader } from "@TaankYou/auth";


var ieFormData = function ieFormData(){
    if(window.FormData == undefined)
    {
        this.processData = true;
        this.contentType = 'application/x-www-form-urlencoded';
        this.append = function(name, value) {
            this[name] = value == undefined ? "" : value;
            return true;
        }
    }
    else
    {
        var formdata = new FormData();
        formdata.processData = false;
        formdata.contentType = false;
        return formdata;
    }
}


/**
 * Class used to handle API calls
 */
export default class Api{
    constructor(url){
        this.url = url;
        this.headers = {
            "X-Language": (window.navigator.userLanguage || window.navigator.language).split("-")[0],
            "X-Application-Id": "dashboard",
            "X-For-Business": "1"
        };
        this.webStorage = new WebStorage(window.localStorage || window.sessionStorage);
        this.log_errors = true;
        this.cookies = false;
    }

    enableCookies() {
        this.cookies = true;
    }

    /**
     * Will add headers to instance
     *
     * @param {*} data
     */
    addHeaders(data = {}){
        for(let h in data){
            if (data.hasOwnProperty(h))
                this.headers[h] = data[h];
        }
    }

    /**
     * Will replace instance's headers
     * @param {*} data
     */
    setHeaders(data = null){
        this.headers = data;
    }

    getUser(){
        if (IsLogged()) {
            return this.get("/customers", { handleUnauth: false })
                .then(res => {
                    let customer = res.customer;
                    if(customer && customer.business_id) {
                        if (!Registry.registered("user"))
                            Registry.register("user", customer);

                        return customer;
                    }
                    else {
                        NotificationManager.error("Votre compte n'est pas un compte professionnel");
                        return Promise.reject(false);
                    }
                })
                .catch(() => { return false; })
        }

        return Promise.reject(false);
    }

    /**
     *
     * @param {string} method POST, GET, PUT, DELETE
     * @param {string} endpoint
     * @param {*} data POST data if needed empty for no body
     * @param {object} opt
     */
    _fetch(method, endpoint, data=null, opt={}){
        // Base header construction
        let _headers = new Headers(this.headers);

		/**
		 * Retrieving csrf headers
		 */
		//let csrf_token = this.webStorage.getItem("csrf_token");

		//if(csrf_token)
		//	_headers.set("X-Csrf-Token", csrf_token);

        let response_type = 'json';
        if(opt.response_type)
            response_type = opt.response_type;

        let URL = this.url + endpoint;
        if(opt.only_endpoint)
            URL = endpoint;

        // Request options, method, headers and body if needed
        let options = {
            method: method,
            headers: _headers
        };

        if(this.cookies && !opt.no_cookies)
            options['credentials'] = "include";
        
        
        if(IsLogged())
            options.headers.append("Authorization", GetAuthorizationHeader());

        /*
         * Creating body if needed
         */
        if(data !== null){
            let formData = new ieFormData();
            Object.keys(data).forEach(key => {
                let value = data[key];
                if(value !== undefined){
                    if (Array.isArray(value))
                        value.forEach(subValue => formData.append(key + "[]", subValue))
                    else
                        formData.append(key, value)
                }
            });
            options.body = formData;
        }

        /**
         * Main call
         */
        return fetch(URL, options)
            .then(res => {
                if(!res.ok || (res.status !== 200 && res.status !== 201))
                    return res.json().then(e => {throw e;});

                if(response_type === 'json')
                    return res.json();
                else if(response_type === 'blob')
                    return res.blob();
                else if(response_type === 'text')
                    return res.text();
            })
            .then( res => { return Promise.resolve(res); })
            .catch(e => {
                if((opt.handleUnauth === undefined || opt.handleUnauth === true) && e.subcode && e.subcode === "AuthUnauthorized"){
                    const { protocol, host } = window.location;
                    SignOut(`${protocol}//${host}`);
                }

                throw e;
            });
    }

    get(endpoint, opt={}){
        return this._fetch("GET", endpoint, null, opt);
    }

    del(endpoint, data, opt={}){
        return this._fetch("DELETE", endpoint, data, opt);
    }

    post(endpoint, data, opt={}){
        return this._fetch("POST", endpoint, data, opt);
    }

    put(endpoint, data, opt={}){
        return this._fetch("PUT", endpoint, data, opt);
    }

    download(endpoint, filename, opt={}){
        return this._fetch("GET", endpoint, null, {
            response_type: 'blob',
            ...opt
        })
            .then(blob => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(url);  
                }, 100);  
            })
            .catch(e => {
                throw e;
            });
    }
}



// WEBPACK FOOTER //
// ./src/Utils/Api.js